import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CollectionFolderViewerComponent } from './collection-folder-viewer.component';
import { ManageLibraryCollectionFolderModule } from '../manage-library-collection-folder/manage-library-collection-folder.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		ManageLibraryCollectionFolderModule
	],
	declarations: [
		CollectionFolderViewerComponent
	],
	exports: [
		CollectionFolderViewerComponent
	]
})
export class CollectionFolderViewerModule {}
